import http from '../api/public'
// const ClientServerApi='/ClientServerApi'
//const deviceApi='http://139.199.0.152/device'

//获取宠物品种列表
export const petType = (params) => {
	return http.fetchPost('/newApi/service/api/device/pet/breed_list',params)
}
//获取协寻评论
export const getComment = (params) =>{
	return http.fetchPost('/newApi/service/api/comment/get',params)
}
//增加协寻评论
export const addComment = (params) =>{
	return http.fetchPost('/newApi/service/api/comment/add',params)
}
//获取国家或地区区号
export const areaCode = (params) =>{
	return http.fetchPost('/newApi/service/basic/countrys/all',params)
}
//邮箱号注册
export const emailRegister2 = (params) =>{
	return http.fetchPost('/newApi/service/authentication/h5/register/default',params)
}
//发送验证码(邮箱)
export const sendCode2 = (params) =>{
	return http.fetchPost('/newApi/service/authentication/vaildCode/send',params)
}
//校验验证码
export const checkCode2 = (params) =>{
	return http.fetchPost('/newApi/service/authentication/vaildCode/vaild',params)
}
//忘记密码
export const resetPsw2 = (params) =>{
	return http.fetchPost('/newApi/service/authentication/password/reset',params)
}

//获取用户所有信息
export const index = (params) => {
	return http.fetchPost('/newApi/service/api/search/index',params)
}
//用户绑定
export const bind = (params) => {
	return http.fetchPost('/newApi/device/devices/bind ',params)
}
//用户解除绑定
export const unbind = (params) => {
	return http.fetchPost('/newApi/device/devices/unbind ',params)
}
//添加宠物
export const add_pet = (params) => {
	return http.fetchPost('/ClientServerApi/pets/info/addPet',params)
}
//绑定宠物
export const bind_pet = (params) => {
	return http.fetchPost('/newApi/service/api/device/bind_pet ',params)
}
//修改用户基本信息
export const updateBasicInfo = (params) => {
	return http.fetchPost('/newApi/updateBasicInfo',params)
}
//获取用户信息
export const getuserinfo = (params) => {
	return http.fetchPost('/newApi/service/user/authUserInfo/get',params)
}

//微信分享
export const weixinshare = (params) => {
	return http.fetchPost('/sign',params)
}


//首次上传图片反馈
export const updateimg = (params) => {
	return http.fetchPost('/service/resource/fastdfs/upload/file/sample',params)
}



// WEBPACK FOOTER //
// ./src/apiNew/index.js